/**
 * Query name for content type
 *
 * @example
 * `/?content=raw` or `/?content=editorial`
 */
export const queryContent = "content";

export const queryLimit = "limit";
export const defaultLimit = "150";
